import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateCameraTrapDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateCameraTrap(
  cameraTrapId: string,
  data: UpdateCameraTrapDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.devices.cameraTraps.update(cameraTrapId),
    data,
  );
  return response.data;
}
